import { defineComponent as _defineComponent } from 'vue'
import {ref, computed, watch, onMounted} from 'vue'
import { useRoute, useRouter } from "vue-router";
import type { checklistPrimaryNode } from './checklist-types';
import { useRegistrationStore } from '@/store/registration';
import emitter from "../../events";
import { useFilterStore } from '@/store/filter';
import { toggleCollapse } from './navState';
import { Builders } from '@busy-human/hxp-library';
import { useBuilderStore } from '@/store/builder';
const ALPHABET = 'abcdefghijklmnopqrstuvwxyz';
const ALPHABET_LENGTH = 26;

export default /*#__PURE__*/_defineComponent({
  __name: 'checklist',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();
const registrationStore = useRegistrationStore();
const checklist  = computed<checklistPrimaryNode[]>(()=> registrationStore.checklistContent);
const currentStep  = computed(()=> registrationStore.currentStep);
const currentSubStep  = computed(()=> registrationStore.currentSubStep);''
const completedSteps  = computed<string[]>(()=> registrationStore.completedSteps);

const showPolicies = ref(false);
const selectedPolicy = ref("none");

const builderStore = useBuilderStore()

const isAdult = ref(false);

watch(() => builderStore.currentBuilder, (record) => {
	if(record){
		isAdult.value = Builders.IsBuilderAdult(builderStore.currentBuilder as Builders.Model);
	}
},{immediate: true});

const filterApplies = (filterString: string) => {
	
	if(filterString === 'isAdult') return isAdult.value
	return true
}

const isCurrent = (check:checklistPrimaryNode)=>{
	const spliteRoute = route.path.split("/");
	if(check.pathName === `/${spliteRoute[2]}`){
		return true;
	}else{
		return false;
	}
};

const subIndexAsCharacters = (idx: number):string => {
	const subCharacterCount = idx / ALPHABET_LENGTH;
	const subCharacterIdx = idx % ALPHABET_LENGTH;
	
	let subIndexChars = "";
	for(let i = 0; i <= subCharacterCount; i++){
		subIndexChars += ALPHABET[subCharacterIdx];
	}

	return subIndexChars;
};



const isStepComplete = (step:number, check: string, subStep?: number) => {

	if(!checklist.value) return false;

	if(check === "Payment"){
		if(completedSteps.value.includes("Deposit Successful")){
			return true;
		}
	}


	if(completedSteps.value.includes(check)){
		return true;
	}else{
		return false;
	}

};


const availableSteps = computed(() => registrationStore.availableSteps);

function checkIfAvailable(step:number){
	if(availableSteps.value.includes(step)){
		return true;
	}
	return false;
}

function isPolicyComplete(subIdx:number){
	const policies = ["Deal Breakers", "Refund Policy", "Contingency Plan","Vaccine Agreement","Builder Agreement", "Parent Requirements"];
	const policy = policies[subIdx];
	if(completedSteps.value.includes(policy)){
		return true;
	}else{
		return false;
	}
}

const routeToChecklist = (name:string, step:number, subStep?: number) => {
	if(name === "Policies"){
		showPolicies.value = !showPolicies.value;
	}else{
		showPolicies.value = false;
		selectedPolicy.value = "none";
		emitter.emit("openPolicy", selectedPolicy.value);
		toggleCollapse(true);
	}
	const isAvailable = checkIfAvailable(step);
	if(isAvailable){
		const path = checklist.value[step].pathName;
		
		if(path){
			router.push(`/registration${path}`);
		}
	}
};

function openPolicy(policy:string){
	if(availableSteps.value.includes(3)){

		if(selectedPolicy.value === policy){
			selectedPolicy.value = "none";
		}else{
			selectedPolicy.value = policy;
		}

		emitter.emit("openPolicy", policy);
		toggleCollapse(true);
	}

}

emitter.on("selectedPolicy", (policy)=>{
	selectedPolicy.value = policy;
});


const __returned__ = { route, router, registrationStore, checklist, currentStep, currentSubStep, completedSteps, ALPHABET, ALPHABET_LENGTH, showPolicies, selectedPolicy, builderStore, isAdult, filterApplies, isCurrent, subIndexAsCharacters, isStepComplete, availableSteps, checkIfAvailable, isPolicyComplete, routeToChecklist, openPolicy, ref, computed, watch, onMounted, get useRoute() { return useRoute }, get useRouter() { return useRouter }, get useRegistrationStore() { return useRegistrationStore }, get emitter() { return emitter }, get useFilterStore() { return useFilterStore }, get toggleCollapse() { return toggleCollapse }, get Builders() { return Builders }, get useBuilderStore() { return useBuilderStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})